/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_UpcomingInputs */

const id_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendatang`)
};

const ms_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const da_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const de_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehend`)
};

const en_us2_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const es_es2_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const es_mx2_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const fil_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparating`)
};

const fr_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const it_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimi`)
};

const hu_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő`)
};

const nl_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomend`)
};

const no_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const pl_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące`)
};

const pt_br2_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const pt_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const ro_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viitoare`)
};

const fi_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat`)
};

const sv_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande`)
};

const vi_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

const tr_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan`)
};

const cs_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející`)
};

const bg_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящи`)
};

const ru_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро выйдет`)
};

const uk_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майбутні`)
};

const ar_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة`)
};

const hi_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी`)
};

const th_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจะมา`)
};

const ja_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開`)
};

const zh_cn2_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将发布`)
};

const zh_hant1_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將發布`)
};

const ko_home_hero_upcoming = /** @type {(inputs: Home_Hero_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Home_Hero_UpcomingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_upcoming = /** @type {((inputs?: Home_Hero_UpcomingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_UpcomingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_upcoming(inputs)
	if (locale === "ms") return ms_home_hero_upcoming(inputs)
	if (locale === "da") return da_home_hero_upcoming(inputs)
	if (locale === "de") return de_home_hero_upcoming(inputs)
	if (locale === "en-US") return en_us2_home_hero_upcoming(inputs)
	if (locale === "es-ES") return es_es2_home_hero_upcoming(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_upcoming(inputs)
	if (locale === "fil") return fil_home_hero_upcoming(inputs)
	if (locale === "fr") return fr_home_hero_upcoming(inputs)
	if (locale === "it") return it_home_hero_upcoming(inputs)
	if (locale === "hu") return hu_home_hero_upcoming(inputs)
	if (locale === "nl") return nl_home_hero_upcoming(inputs)
	if (locale === "no") return no_home_hero_upcoming(inputs)
	if (locale === "pl") return pl_home_hero_upcoming(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_upcoming(inputs)
	if (locale === "pt") return pt_home_hero_upcoming(inputs)
	if (locale === "ro") return ro_home_hero_upcoming(inputs)
	if (locale === "fi") return fi_home_hero_upcoming(inputs)
	if (locale === "sv") return sv_home_hero_upcoming(inputs)
	if (locale === "vi") return vi_home_hero_upcoming(inputs)
	if (locale === "tr") return tr_home_hero_upcoming(inputs)
	if (locale === "cs") return cs_home_hero_upcoming(inputs)
	if (locale === "bg") return bg_home_hero_upcoming(inputs)
	if (locale === "ru") return ru_home_hero_upcoming(inputs)
	if (locale === "uk") return uk_home_hero_upcoming(inputs)
	if (locale === "ar") return ar_home_hero_upcoming(inputs)
	if (locale === "hi") return hi_home_hero_upcoming(inputs)
	if (locale === "th") return th_home_hero_upcoming(inputs)
	if (locale === "ja") return ja_home_hero_upcoming(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_upcoming(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_upcoming(inputs)
	return ko_home_hero_upcoming(inputs)
});
export { home_hero_upcoming as "home.hero.upcoming" }